module.exports = __webpack_public_path__ + "static/img/14000771.aa073e71.png";